import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
`;

export const Title = styled.div`
  ${(p) => p.theme.typography.title};
`;

export const LinksWrapper = styled.div`
  a {
    color: inherit;
    text-decoration: underline;
  }
`;
